export default "__VITE_ASSET__MBrueLBR__"